import React, { FC, useEffect, useState } from "react";

import railsFetch from "../../railsFetch";
import { RegistrationCheckPoint } from "./types";
import { Button } from "@primer/react";
// @ts-ignore
import { Table, type TableCellProps } from "@primer/react/experimental";


export interface CheckinCellProps {
  checkPoint: RegistrationCheckPoint;
  onReload?: () => void;
}

export const CheckinCell: FC<CheckinCellProps> = ({
  checkPoint: initialCheckpoint,
  onReload,
}) => {
  const [checkPoint, setCheckPoint] =
    useState<RegistrationCheckPoint>(initialCheckpoint);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => setCheckPoint(initialCheckpoint), [initialCheckpoint]);

  const handleChange = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await railsFetch(checkPoint.url, {
        method: checkPoint.arrived ? "DELETE" : "PUT",
      });
      setCheckPoint({ ...checkPoint, arrived: !checkPoint.arrived });
      onReload?.();
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const text = checkPoint.arrived ? "Check out" : "Check in";
  const variant = checkPoint.arrived ? "danger" : "primary";

  return (
    <Table.Cell>
      <Button
        type="button"
        variant={variant}
        disabled={loading}
        onClick={handleChange}
        block={true}
      >
        {text}
      </Button>
    </Table.Cell>
  );
};
